import RootLayout from "../layouts/main/RootLayout"
import RequireAuthorization from "../components/Authorization"
import User from "../pages/User"
import DeviceSetting from "../pages/DeviceSetting"
import Home from "../pages/Home"
import Unauthorization from "../pages/UnAuthorization"
// import ConnectedDevice from "../pages/ConnectedDevice"
import DeviceList from "../pages/DeviceListDev"

const UserRouters = {
  path: "/",
  element: <RootLayout />,
  children: [
    {
      element: <RequireAuthorization role={"user"} key={"auth"} />,
      children: [
        {
          path: "",
          element: <Home />,
        },
        {
          path: "user",
          element: <User />,
          children: [
            {
              path: "connected-devices",
              // element: <ConnectedDevice />,
              element: <DeviceList />,
            },
            {
              path: "connected-devices/:client_id/setting",
              element: <DeviceSetting />,
            },
          ],
        },
        {
          path: "unauthorized",
          element: <Unauthorization />,
        }
      ],
    },
  ],
}

export default UserRouters
